import React from 'react';
import { EmptyState } from '../../../../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { AssetAllocationDTO } from '../../../../../../../../api/useAccountsOptionsQuery';
import { AllocationTaxStatusDTO } from '../../../../../../../../api/useAccountsQuery';
import { useAccountFormContext } from '../../../../context/useAccountFormContext';
import { HypotheticalReturn } from '../../../HypotheticalReturn/HypotheticalReturn';
import { AllocationContent } from '../AllocationContent/AllocationContent';
import { useAggregatedPositions } from './useAggregatedPositions';

interface Props {
  assetAllocationTaxStatus: AllocationTaxStatusDTO | null;
}

export const AggregatedPositions = ({ assetAllocationTaxStatus }: Props) => {
  const { data } = useAggregatedPositions({ assetAllocationTaxStatus });

  if (!data) {
    return (
      <Box py="24">
        <EmptyState />
      </Box>
    );
  }

  return (
    <AggregatedPositionsContent
      assetAllocationTaxStatus={assetAllocationTaxStatus}
      chartValues={data.chartValues}
    />
  );
};

interface AggregatedPositionsContentProps {
  assetAllocationTaxStatus: AllocationTaxStatusDTO | null;
  chartValues: AssetAllocationDTO[];
}

const AggregatedPositionsContent = ({
  assetAllocationTaxStatus,
  chartValues,
}: AggregatedPositionsContentProps) => {
  const {
    localSaveOptions,
    options: { ShowHypotheticalReturn: showHypotheticalReturn },
  } = useAccountFormContext();

  return (
    <>
      {(localSaveOptions ? localSaveOptions.showHypotheticalReturn : showHypotheticalReturn) && (
        <Box pt="16" maxWidth="50%">
          <HypotheticalReturn />
        </Box>
      )}

      <AllocationContent
        chartValues={chartValues}
        assetAllocationTaxStatus={assetAllocationTaxStatus}
        readOnly
      />
    </>
  );
};
